
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot } from "@angular/router";
import { Observable } from 'rxjs';
import { UsuarioService } from './shared/services/acordo-ressarcimento/api/services';

@Injectable()
export class AuthGuard implements CanActivate {
  public perfisUsuario: String[];
  public perfisRestringidos = [];

  constructor(private usuarioService: UsuarioService) {
      //if( this.perfisUsuario == null ) {
        this.usuarioService.recuperarDadosUsuario().subscribe( result => {
            this.perfisUsuario = result.perfis
          } );
     // }
  }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | boolean {
    switch (route.url[0].path) {
      case 'repassar-valores-acordo': {
        this.perfisRestringidos = ["admauto", "gestorauto", "seniorauto", "coordenadorauto", "gerenteauto", "supauto", "escritorioadmauto", "escritorioauto", "gestorfianca", "escritorioadmfianca"];
        return this.verificaPerfis(this.perfisRestringidos);
      }
      case 'consultar-lote-fatura': {
        this.perfisRestringidos = ["admauto", "gestorauto", "seniorauto", "coordenadorauto", "gerenteauto", "supauto", "escritorioadmauto", "escritorioauto"];
        return this.verificaPerfis(this.perfisRestringidos);
      }
      case 'detalhe-lote-fatura': {
        this.perfisRestringidos = ["admauto", "gestorauto", "seniorauto", "coordenadorauto", "gerenteauto", "supauto", "escritorioadmauto", "escritorioauto"];
        return this.verificaPerfis(this.perfisRestringidos);
      }
      case 'pagador-lote-fatura': {
        this.perfisRestringidos = ["admauto", "gestorauto", "seniorauto", "coordenadorauto", "gerenteauto", "supauto", "escritorioadmauto", "escritorioauto"];
        return this.verificaPerfis(this.perfisRestringidos);
      }
      case 'conciliacao-importar-extrato': {
        this.perfisRestringidos = ["escritorioadmauto", "escritorioauto"];
        return this.verificaPerfis(this.perfisRestringidos);
      }
      case 'conciliacao-extrato': {
        this.perfisRestringidos = ["escritorioadmauto", "escritorioauto"];
        return this.verificaPerfis(this.perfisRestringidos);
      }
      case 'pagamento-honorario': {
        this.perfisRestringidos = ["escritorioadmfianca", "escritoriofianca"];
        return this.verificaPerfis(this.perfisRestringidos);
      }
      case 'detalhe-honorario': {
        this.perfisRestringidos = ["gestorfianca", "escritorioadmfianca", "escritoriofianca"];
        return this.verificaPerfis(this.perfisRestringidos);
      }
      case 'relatorio-conciliacao': {
        this.perfisRestringidos = ["admfianca", "gestorfianca", "seniorfianca", "coordenadorfianca", "gerentefianca", "supfianca", "escritorioadmfianca", "escritoriofianca"];
        return this.verificaPerfis(this.perfisRestringidos);
      }

      //Abaixo, todas as rotas que não possui restrição
      //case 'acordo': { return true }
      //case 'consultar-proposta': { return true }
      //case 'receber-honorario': { return true }
      //case 'consultar-proposta': { return true }
      //case 'receber-honorario': { return true }
      //case 'detalhe-proposta': { return true }
      //case 'conciliacao': { return true }
      //case 'conciliacao-validacao': { return true }
      //case 'detalhe-validacao': { return true }

      //Ou, podemos substituir os cases comentados acima, com:
      default: { return true }
    }
  }

  public verificaPerfis(perfisRestringidos: String[]): boolean {
    if (this.perfisUsuario == null || this.perfisUsuario.filter(perfisUsuario => perfisRestringidos.find(perfisRestringidos => perfisRestringidos == perfisUsuario)).length == 0) {
      return true;
    } else {
      alert('Você não tem acesso a esta página, por favor, entre em contato com o administrador');
      return false;
    }
  }
}